import type { PaymentPlanResponse } from '@ctct/domain-layer';

import { EventBus } from '../../helpers';

type NonProfitEvents = {
  nonProfitIsChanging: [isChanging: boolean];
  nonProfitChanged: [isNonProfit: boolean];
  nonProfitPaymentPlanGroupIdChanged: [paymentPlanGroupId: number];
  nonProfitPaymentPlanDiscountsChanged: [planDiscounts: PaymentPlanResponse['planDiscounts']];
};

class NonProfitEventBus extends EventBus<NonProfitEvents> {}

export const nonProfitEventBus = new NonProfitEventBus();
